import { cn } from 'utils/helpers'
import styles from './panel.module.scss'

export default function Panel({ children, size, desktop, className = 'mb72', tag = 'div' }) {
    const Tag = tag
    return <Tag className={cn(styles.panel, styles[size], desktop && styles.panelDesktop, className)}>{children}</Tag>
}
